<template>
    <div class="list-box">
        <div class="select-box clear">
            <div class="float-l left-box">
                <span>发布日期：</span>
                <DatePicker :transfer="true" :value="publishDate" @on-change="dateChange" format="yyyy-MM-dd" type="date" style="width: 200px"></DatePicker>
            </div>
            <div class="float-r">
                <Button class="list-btn" @click="getList(publishDate)">查询</Button>
            </div>
        </div>
        <Button type="primary" class="btn-c-common" ref="printMark" v-print="print" v-show="false">公开</Button>
        <Button @click="actionModal.visible=true" type="primary" class="btn-c-common float-r public-btn">重点排放单位信息公开</Button>
        <div class="table-box">
            <Table border :data="tableData" :columns="tableColumns">
                <template slot-scope="{ row }" slot="publishStatus">
                    {{row.publishStatus === 'Y' ? '已公开' : '未公开'}}
                </template>
                <template slot-scope="{ row }" slot="publishDate">
                    {{row.publishDate | getTime('Y')}}
                </template>
                <template slot="reportType">
                    <span>年报</span>
                </template>
                <template slot-scope="{ row }" slot="action">
                    <Button class="action-btn" type="text" @click="view(row)">查看</Button>
                    <Button class="action-btn" type="text" @click="download(row)">下载</Button>
                    <Button class="action-btn" type="text" @click="del(row)">删除</Button>
                </template>
            </Table>
             <Page style="margin-top:20px" @on-change="pIndexChange" :total="page.total" :current="page.currentPage" :page-size="page.pageSize"  class="float-r"/>
        </div>
        <!-- 新增或查看 -->
        <Modal title="重点排放单位信息公开" v-model="actionModal.visible" @on-visible-change="actionModalChange">
            <div class="modal-box">
                <Form ref="actionForm" :model="formData" :rules="formRules" :show-message="false" :hide-required-mark="true">
                    <FormItem prop="year" label="选择年份：">
                        <DatePicker type="year" :value="formData.year" :editable="false" @on-change="yearChange"/>
                    </FormItem>
                    <FormItem prop="industryCode" label="选择行业：">
                        <Select v-model="formData.industryCode" style="width:212px">
                            <Option value="1">电力</Option>
                            <Option value="66">电力（自备电厂）</Option>
                        </Select>
                    </FormItem>
                    <div v-if="formData.year<'2020' && formData.year"  >
                        <FormItem label="附件名称：" prop="fileName">
                            <div class="updata clear">
                                <div>
                                    <Input type="text" v-model="formData.fileName" disabled style="width:220px"/>
                                </div>
                                
                                <div style="margin-top:-30px">
                                    <Button type="primary" class="btn-c-common float-r">
                                        <a href="/file/温室气体重点排放单位信息公开表.docx" download style="color:#fff">模板下载</a>
                                    </Button>
                                    <Upload :before-upload="handleUpload" action class="float-r">
                                        <Button type="primary" class="btn-c-common" style="margin: 0 16px">上传</Button>
                                    </Upload>
                                </div>
                               
                            </div>
                         </FormItem>
                    </div>

                    <div v-else>
                    <div>公开信息包括以下内容，请确认是否公开：</div>
                        <div class="list-card">
                            <div>1、基本信息</div>
                            <div>
                                <span>2、机组及生产设施信息</span>
                                <FormItem prop="unitInfo" style="display:inline-block;margin:-6px 0 0 50px">
                                    <RadioGroup v-model="formData.unitInfo">
                                            <Radio label="Y">公开</Radio>
                                            <Radio label="N">不公开</Radio>
                                    </RadioGroup>
                                </FormItem>
                            </div>
                            <div>3、低位发热量和单位热值含碳量的确定方式</div>
                            <!-- <div>4、排放量信息</div> -->
                            <div>
                                <span>4、排放量信息</span>
                                <FormItem prop="emissions" style="display:inline-block;margin:-6px 0 0 50px">
                                    <RadioGroup v-model="formData.emissions">
                                            <Radio label="Y">公开</Radio>
                                            <Radio label="N">不公开</Radio>
                                    </RadioGroup>
                                </FormItem>
                            </div>
                            <div>5、生产经营变化情况</div>
                            <div>
                                <span>6、编制温室气体排放报告的技术服务机构情况：</span>
                                <div style="padding-left:20px">
                                    <div style="margin-top:10px">编制温室气体排放报告的技术服务机构名称：</div>
                                    <FormItem prop="technicalServiceOrgName" style="margin:6px 0">
                                        <Input v-model="formData.technicalServiceOrgName" />
                                    </FormItem>
                                    <div>编制温室气体排放报告的技术服务机构统一社会信用代码：</div>
                                    <FormItem prop="technicalServiceOrgCreditCode" style="margin:6px 0">
                                        <Input v-model="formData.technicalServiceOrgCreditCode" />
                                    </FormItem>
                                </div>
                            </div>
                            <div>
                                <span>7、重点排放单位是否完成对应履约期的配额清缴与履约</span>
                                <FormItem prop="appointStatus" style="margin:0 0 0 20px">
                                    <RadioGroup v-model="formData.appointStatus">
                                        <Radio label="Y">完成</Radio>
                                        <Radio label="N">未完成</Radio>
                                        <Radio label="C">未纳入碳市场</Radio>
                                    </RadioGroup>
                                </FormItem>
                            </div>
                        </div>                        
                    </div>

                </Form>
            </div>
            <div slot="footer">
                <Button type="text" @click="actionModal.visible=false">取消</Button>
                <Button type="primary" class="btn-c-common" :loading="btn2019Loding" @click="modalOk('actionForm')">确定公开</Button>
            </div>
        </Modal>
        <page-details @onSuccess="onSuccess"  :onlyView="pageDetailsModal.onlyView" :visible.sync="pageDetailsModal.visible" :otherForm="pageDetailsModal.otherForm" :baseInfo="pageDetailsModal.baseInfo" :unitInfoList="pageDetailsModal.unitInfoList" :title="pageDetailsModal.title" :form="pageDetailsModal.form" :determineWays="pageDetailsModal.determineWays" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import pageDetails from './components/PageDetails.vue'
import { uploadFileService ,downloadPdfAPi2020} from "@/api/file";
import { fileDownloadService } from "@/api/file"
import {getInfoDisclosureListService,getPageFileDataService,saveInfoDisclosureService,deleteInfoDisclosureService} from '@/api/info-disclosure'
export default {
    components: { pageDetails },
    data() {
        return {
            docTitle:'',
            file: [], // 文件
            fileId:'',
            publishDate: '',
            actionModal: {
                visible: false,
            },
            btn2019Loding:false,
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 20, //每页数据,
            },
            print: {
                id: 'printArea',
                closeCallback (vue) {
                    document.title = vue.docTitle
                },
                openCallback (vue) {
                    document.title = '温室气体重点排放单位信息公开表'
                },
            },
            pageDetailsModal: {
                visible: false,
                title: '信息公开',
                baseInfo:{},
                unitInfoList:[],
                determineWays:[],
                otherForm:{},
                onlyView:false,
            },
            formData: {
                fileName:'',
                year: '',
                industryCode: '',
                unitInfo: 'Y',
                emissions: 'Y',
                technicalServiceOrgName: '',
                technicalServiceOrgCreditCode: '',
                appointStatus: 'Y'
            },
            formRules: {
                year: [{ required: true, message: '', trigger: 'change' }],
                fileName: [{ required: true, message: '', trigger: 'change' }],
                unitInfo: [{ required: true, message: '', trigger: 'change' }],
                technicalServiceOrgName: [{ required: true, message: '', trigger: 'change' }],
                technicalServiceOrgCreditCode: [{ required: true, message: '', trigger: 'change' }],
                appointStatus: [{ required: true, message: '', trigger: 'change' }],
                industryCode: [{ required: true, message: '', trigger: 'change' }],
            },
            tableData: [
                { posTStatus: '已公开', posTDate: '2021-10-14', year: '2020', postType: '年报', postIndustry: '发电' }
            ],
            tableColumns: [
                { title: '序号', type: 'index', align: 'center' },
                { title: '发布状态', slot: 'publishStatus', align: 'center' },
                { title: '公开日期', slot: 'publishDate', align: 'center' },
                { title: '年份', key: 'year', align: 'center' },
                { title: '报告类型', slot: 'reportType', align: 'center' },
                { title: '行业', key: 'industryName', align: 'center' },
                { title: '操作', slot: 'action', align: 'center', width: 220 },
            ]
        }
    },
    
    created() {
        this.docTitle = document.title
        this.getList()
    },
    computed: {
        ...mapGetters(["getUserInfo"]),
        companyId() {
            return this.getUserInfo.user.companyId;
        },

    },
    methods: {

        handleUpload(file){
            const fileFormat = file.name.substring(file.name.lastIndexOf('.') + 1)
            if (!['pdf'].includes(fileFormat)) {
                this.$Message.error('请上传pdf文件')
                return false
            }
            this.file = file;
            this.formData.fileName = this.file.name;
            return false;
        },
        // 页码变化
        pIndexChange(val) {
          this.page.currentPage = val;
          this.getList();
        },
        getList(publishDate) {
            let params = {
                companyId:this.companyId,
                publishDate:publishDate? publishDate : this.publishDate,
                page: this.page.currentPage,
                limit: this.page.pageSize,
            }
            getInfoDisclosureListService(params).then(res=>{
                this.tableData = res.body.list
                this.page.total = res.body.total;
            })
        },
        view(row){
            let query = {}
            query = row.year < '2020' ? {id:row.fileId} : {infoId:row.id}
            let routeData = this.$router.resolve({
                name:'PdfView',
                query:query
            })
            window.open(routeData.href,'_blank')

        },
        del(row){
            deleteInfoDisclosureService({infoId:row.id}).then(res=>{
                if(res.status === 200) {
                    if(this.tableData.length ===1 ) {
                        if (this.page.currentPage !== 1) {
                            this.page.currentPage -= 1
                        }
                    }
                    this.$Message.success('删除成功')
                    this.getList()
                }
            })
        },
        async download(row){
            if(row.year < '2020'){
                let params = {
                    id:row.fileId
                }
                fileDownloadService(params);
            } else {
                let params = {
                    infoId:row.id
                }
                downloadPdfAPi2020(params)
            }
            
        },

        onSuccess(data){
            this.actionModal.visible=false
            saveInfoDisclosureService(data).then(res=>{
                this.$Message.success('公开成功')
                this.getList()
            })
        },
        getPdfData(params,modalData,openModal){
            getPageFileDataService(params).then(res=>{
                console.log(res)
                if(res.status === 200) {
                            this.pageDetailsModal.baseInfo=res.body.baseInfo
                            this.pageDetailsModal.determineWays=res.body.determineWays
                            this.pageDetailsModal.unitInfoList=res.body.unitInfoList
                            let otherForm = {
                                totalUnitEmission:res.body.baseInfo.totalUnitEmission,
                                technicalServiceOrgName: modalData.technicalServiceOrgName,
                                technicalServiceOrgCreditCode: modalData.technicalServiceOrgCreditCode,
                                appointStatus: modalData.appointStatus,
                                year: modalData.year,
                                unitInfo: modalData.unitInfo,
                                emissions: modalData.emissions,
                                industryCode:modalData.industryCode,
                                industryName:modalData.industryCode==1 ? '电力' : '电力（自备电厂）'
                            }
                            this.pageDetailsModal.otherForm = otherForm
                            if(openModal && openModal === 'noOpen'){
                                this.pageDetailsModal.visible = false
                            } else {
                                this.pageDetailsModal.visible = true
                            }
                } else {
                    this.$Message.error(res.message)
                }
                        
            })
        },
        modalOk(ref) {
            if(this.formData.year < '2020'){
                this.$refs[ref].validate(async valid => {
                    if(valid){
                        this.btn2019Loding = true
                        let params = {
                            file: this.file,
                            fileType:'信息汇总',
                            dataType:'infoDisclosure'
                        }
                         const { data } = await uploadFileService(params);
                         this.fileId = data.body.fileId
                         let parmas2 = {
                             info :{
                             companyId:this.companyId,
                             year:this.formData.year,
                             industryCode:this.formData.industryCode,
                             industryName:this.formData.industryCode==1 ? '电力' : '电力（自备电厂）',
                             fileId:this.fileId,
                             basicInfo:'Y',
                             unitInfo:'Y',
                             lowCarbonCalorific:'Y',
                             emissions:'Y',
                             productionOperation:'Y',
                             technicalServiceOrgName:'',
                             technicalServiceOrgCreditCode:'',
                             appointStatus:'Y',
                             totalUnitEmission:'',
                             postalCode:'',
                             companyIntroduction:'',
                             companyName:'',
                             identityCode:'',
                             permitCode:'',
                             legalPerson:'',
                             manufactureAddress:'',
                             companyIndustryName:'',
                             guideIndustryType:''
                         },
                         unitInfoList:[],
                         determineWayList:[]
                         }
                        saveInfoDisclosureService(parmas2).then(res=>{
                            if(res.status === 200) {
                                this.$Message.success('公开成功')
                                this.actionModal.visible = false
                                this.btn2019Loding = false
                                this.getList()                            }
                        }).catch(err=>{
                            this.btn2019Loding = false
                        })
                    }
                })
            }else {
                this.pageDetailsModal.onlyView = false
                this.$refs[ref].validate(valid => {
                    if (valid) {
                        let modalData = {...this.formData}
                         let params = {
                             companyId:this.companyId,
                             year:modalData.year,
                             industryCode:modalData.industryCode
                         }

                         this.getPdfData(params,modalData)

                    }else{
                        console.log('error')
                    }
                })
            }
            
        },
        actionModalChange(visible) {
            if (!visible) {
                this.$nextTick(() => {
                    this.$refs['actionForm'].resetFields();
                    this.file = []
                })
            }
        },
        dateChange(date) {
            this.publishDate = date
        },
        yearChange(year){
            this.formData.year = year
        }
    }
}
</script>

<style lang="less" scoped>
.list-box {
    padding: 40px 50px;
    .select-box {
        background: #009fd9;
        padding: 20px 40px;
        .left-box {
            color: #fff;
        }
        .list-btn {
            width: 100px;
            color: #009fd9;
        }
    }
    .public-btn {
        margin: 20px 0;
    }
    .table-box {
        margin-top: 74px;
        .action-btn {
            color: #009fd9;
        }
    }
}
.modal-box {
    .list-card {
        padding: 20px 30px;
        & > div {
            outline: 1px solid #d7d7d7;
            border-radius: 2px;
            margin-bottom: 10px;
            padding: 5px 6px;
        }
    }
}

.updata {
    & > div:first-of-type {
        float: left;
        width: 50%;
    }

    & > div:last-of-type {
        float: right;
    }
}
</style>